/**
 * ABTestModel 获取AB实验配置信息
 */
import { BaseModel, apolloQuery, QueryResult } from 'vue-apollo-model';
import gql from 'graphql-tag';
import { Query } from '@/generated-models';

export default class ABTestModel extends BaseModel {
    @apolloQuery<ABTestModel>({
        query: gql`
            query getStartupQuery {
            visionStartup
            }
        `,
        prefetch: true,
    })
    startupInfo!: QueryResult<{ visionStartup: Query['visionStartup'] }>;

    get newRecoABTest() {
        return this.startupInfo.data.visionStartup?.homeRecoAbTest || 0;
    }


    hasNewReco() {
        if (this.newRecoABTest === 1 || this.newRecoABTest === 2) {
            return true;
        }
        return false;
    }
}
